import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'
import type { CommunityEssentialModel } from '@/models'

import { ESSENTIAL_ICON_MAP, EXTERNAL_LINK_TYPES } from '../community-essentials.constants'
import { getEssentialHref } from '../community-essentials.utils'
import * as S from './client-essential-item.styled'

interface ClientEssentialItemProps {
  item: CommunityEssentialModel
}

export const ClientEssentialItem = ({ item }: ClientEssentialItemProps) => {
  const IconComponent = ESSENTIAL_ICON_MAP[item.icon]
  const href = getEssentialHref(item.type, item.value)
  const isExternalLink = EXTERNAL_LINK_TYPES.includes(item.type)

  return (
    <S.Row>
      {IconComponent && (
        <S.IconWrapper>
          <Icon icon={IconComponent} size="2rem" />
        </S.IconWrapper>
      )}
      <Typography breakLines={1} size="text-small" weight="medium">
        {item.name}
      </Typography>
      {href ? (
        <S.Value
          href={href}
          rel={isExternalLink ? 'noopener noreferrer' : undefined}
          target={isExternalLink ? '_blank' : undefined}
        >
          {item.value}
        </S.Value>
      ) : (
        <S.Value as="span">{item.value}</S.Value>
      )}
    </S.Row>
  )
}
